import { observer } from 'mobx-react';
import React, { Fragment, useEffect } from 'react';
import { EqualHeightProvider, Grid, Notice, Separator, Spinner } from 'telia-front-react';
import { FetchStatus } from '../../../util/FetchStatus';
import Telia1BenefitCard from './Telia1BenefitCard';
const Telia1BenefitsComponent = (props) => {
    var _a, _b, _c, _d;
    const { translate, telia1Store, onBenefitsLoaded, invalid, renderAsOptionCards } = props;
    useEffect(() => {
        if (telia1Store.status === FetchStatus.FETCHED) {
            onBenefitsLoaded &&
                onBenefitsLoaded(telia1Store.totalEffectiveBenefitsCount, telia1Store.anyPassedInTotal, telia1Store.promotionEligibilitiesMaxBenefitsCountSum);
        }
    }, [telia1Store.promotionEligibility]);
    const renderCouponNotice = (couponCode) => {
        const warningNotice = translate(`telia1Benefit.grid.${couponCode}.notice.warning`);
        const infoNotice = !warningNotice && translate(`telia1Benefit.grid.${couponCode}.notice.info`);
        return renderNotice(warningNotice, 'attention') || renderNotice(infoNotice, 'info');
    };
    const renderNotice = (content, type) => {
        return (!!content && (React.createElement(Fragment, { key: content },
            React.createElement(Separator, { spacing: 'xsmall', color: 'invisible' }),
            React.createElement(Notice, { type: type }, content))));
    };
    if (telia1Store === null || telia1Store === void 0 ? void 0 : telia1Store.areBenefitsFetching) {
        return React.createElement(Spinner, null);
    }
    if (telia1Store.status === FetchStatus.ERROR) {
        return React.createElement(Notice, { type: "error" }, translate('telia1Benefit.error'));
    }
    const renderCard = (benefit, index, promotionName) => {
        return (React.createElement(Telia1BenefitCard, { key: `${benefit.code}-${index}`, promotionName: promotionName, benefit: benefit, index: index, optionProps: renderAsOptionCards
                ? {
                    invalid,
                }
                : null, ...props }));
    };
    const renderGridFragment = (promotionEligibility, index) => {
        return (React.createElement(Fragment, { key: `${promotionEligibility.promotion.name}-${index}` }, promotionEligibility.promotionBenefits.map((benefit, i) => renderCard(benefit, i, promotionEligibility.promotion.name))));
    };
    return (React.createElement(React.Fragment, null,
        telia1Store.availableBenefitsCount(telia1Store.parentPromotionName) === 0 && !!telia1Store.newBenefitsAvailableFrom && (React.createElement(React.Fragment, null,
            React.createElement(Notice, { type: 'attention' }, translate('telia1Benefit.nextBenefitsAvailableFrom', {
                date: telia1Store.newBenefitsAvailableFrom,
            })),
            React.createElement(Separator, { spacing: 'small', color: 'invisible' }))),
        React.createElement(EqualHeightProvider, { groups: ['card-header'] },
            React.createElement(Grid, { equalHeight: true }, telia1Store.promotionEligibilities.map(renderGridFragment))),
        renderAsOptionCards && ((_a = telia1Store.selectedBenefitCodes) === null || _a === void 0 ? void 0 : _a.map((code) => renderCouponNotice(code))),
        renderAsOptionCards && (!!((_b = telia1Store.disabledChildren) === null || _b === void 0 ? void 0 : _b.length) || !!((_c = telia1Store.disabledReplaceParents) === null || _c === void 0 ? void 0 : _c.length)) && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: 'xsmall', color: 'invisible' }),
            React.createElement(Notice, { type: 'attention' }, translate(`telia1Benefit.upgrade.notice${!!((_d = telia1Store.disabledReplaceParents) === null || _d === void 0 ? void 0 : _d.length) ? '.parent' : ''}`)))),
        invalid && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: 'xsmall', color: 'invisible' }),
            React.createElement(Notice, { size: 'small', type: 'error' }, translate('telia1Benefit.makeSelectionForProceeding'))))));
};
export default observer(Telia1BenefitsComponent);
